import { render, staticRenderFns } from "./LessonList.vue?vue&type=template&id=5b081444&"
import script from "./LessonList.vue?vue&type=script&lang=js&"
export * from "./LessonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports